module.exports = __webpack_public_path__ + "static/img/alicante.7861f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/alicante.jpg
// module id = eyX1
// module chunks = 1